<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">그룹코드관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>그룹코드</p>
                <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.code" @change="fn_search_change">
              </li>
              <li>
                <p>그룹코드명</p>
                <input type="text" placeholder="코드명을 입력하세요" class="form_control" v-model="searchInfo.codeNm" @change="fn_search_change">
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list mb40">
            <div class="table_option">
              <div class="page_title pb0">그룹코드</div>
              <button class="btn btn_md btn_darkblue" v-b-modal.aroundModal @click="fn_move_reg_page">신규 등록</button>
            </div>
            <table class="list">
              <thead>
                <tr>
                    <th>코드</th>
                    <th>코드명</th>
                    <th>설명</th>
                    <th>사용유무</th>
                    <th>처리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="codeList.length == 0">
                    <td colspan="5"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in codeList" :key="index" @click="fn_grpCode_click(item.code,item.code_nm)" :class="{ active: selectedCode === item.code }">
                  <td><span>{{ item.code }}</span></td>
                  <td><span>{{ item.code_nm }}</span></td>
                  <td class="al"><span>{{ item.code_expl }}</span></td>
                  <td><span>{{ item.use_yn }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_del" @click="fn_del_grp(item.code)" ></button>
                      <button class="icon icon_edit" @click="fn_modify_grp(item.code)"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="moveGrpPage" v-show="page1Show"/>
          </div>
          <div class="table_list">
            <div class="table_option">
              <div class="page_title pb0">상세코드</div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_reg_dtl_page">신규 등록</button>
            </div>            
            <table class="list">
              <thead>
                <tr>
                    <th>코드</th>
                    <th>코드명</th>
                    <th>사용유무</th>
                    <th>처리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="codeDetailList.length == 0">
                    <td colspan="4"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in codeDetailList" :key="index">
                  <td><span>{{ item.dtl_code }}</span></td>
                  <td><span>{{ item.dtl_code_nm }}</span></td>
                  <td><span>{{ item.use_yn }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_del" @click="fn_del_dtl(item.dtl_code)"></button>
                      <button class="icon icon_edit" @click="fn_modify_dtl(item.dtl_code)"></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination2 :pageInfo=pageInfo2 @clickPage="moveDtlPage" v-show="page2Show"/>            
          </div>
        </section>
      </div>
    </div> 
       
</template>
<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import Pagination2 from "@/components/AdminPagination.vue"
    import merge from 'lodash/merge';
    import cloneDeep from 'lodash/cloneDeep';


    export default {
        name: 'CodeMngt',
        components: {      
            Pagination,
            Pagination2,
        },
        data() {
            return {
                searchInfo : {
                    code : '',
                    codeNm : '',
                    pageInfo : {
                      page : 1,
                      pageSize : 5,
                      totPage : 0
                    }                
                },
                grpCode : '',
                grpCodeNm : '',
                searchChange : false,
                codeList : [],
                codeDetailList : [],
                page1Show : false,
                page2Show : false,
                pageInfo2 : {
                  code:'',
                  page : 1,
                  pageSize : 5,
                  totPage : 0
                },
                originSearchInfo :{},
                selectedCode : ''
            }
        },
        created(){
          //검색정보 처리
          let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];

          console.log("@@@@ creta searchInfoStore : %o ",searchInfoStore);

          if(searchInfoStore != null && Object.keys(searchInfoStore).length > 0){
            this.searchInfo = merge(
                {},
                cloneDeep(this.searchInfo),
                cloneDeep(searchInfoStore)
            );
          }

          this.originSearchInfo = cloneDeep(this.searchInfo);
        },
        mounted(){
          this.fn_search();
        },
        methods : {
            fn_search(){

                if(this.searchChange){
                  this.searchInfo.pageInfo.page = 1;
                  this.searchChange = false;

                }

                console.log("@@@ fn_search searchInfo : %o",this.searchInfo);

                axios
                    .post("/api/system/searchCode", this.searchInfo)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.codeList = res.data.codeInfo;

                        console.log("@@@@ codeList : %o",this.codeList);

                        this.searchInfo.pageInfo.totPage = res.data.totCnt;
                        
                        if(this.searchInfo.pageInfo.totPage> 0){
                          this.page1Show = true;                          
                        }

                        // 검색 정보 저장
                        this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo);
                        this.originSearchInfo = cloneDeep(this.searchInfo);

                    })
                    .catch((err) => console.log(err));
                
            },
            fn_move_reg_page(){
                this.$store.dispatch('codeMngt/setCode', '');
                this.$router.push("/admin/system/CodeMngtRegGrp");
            },
            fn_del_grp(code){

              if(confirm("정말로 삭제하시겠습니까?")){
                  let param = new Object();
                  param.grpCode = code;

                  axios
                      .post("/api/system/delCodeGrp", param)
                      .then((res) => {
                          this.fn_search();
                      })
                      .catch((err) => console.log(err));
                }
            },
            fn_modify_grp(code){
              this.$store.dispatch('codeMngt/setCode', code); 
              this.$router.push("/admin/system/CodeMngtRegGrp");
            },
            moveGrpPage(page){
              this.searchInfo.pageInfo.page = page;
              this.fn_search();
              this.codeDetailList = [];
            },
            fn_dtl_search(code){


                console.log("@@@ fn_dtl_search");

                let param = new Object();
                param.code = code;
                this.pageInfo2.code = code;
                param.pageInfo = this.pageInfo2;

                console.log("@@@ fn_dtl_search param : %o",param);

                axios
                    .post("/api/system/searchDtlCode", param)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.codeDetailList = res.data.codeDtlInfo;

                        console.log("@@@@ codeDetailList : %o",this.codeDetailList);

                        this.pageInfo2.totPage = res.data.totCnt;
                        
                        if(this.pageInfo2.totPage> 0){
                          this.page2Show = true;                          
                        }                        

                    })
                    .catch((err) => console.log(err));
                
            },
            fn_move_reg_dtl_page(){
              this.$store.dispatch('codeMngt/setCode', this.grpCode);
              this.$store.dispatch('codeMngt/setCodeNm', this.grpCodeNm);
              this.$router.push({name : 'CodeMngtRegDtl'});
            },
            fn_modify_dtl(code){
              this.$store.dispatch('codeMngt/setDtlCode', code); 
              this.$router.push({name : 'CodeMngtRegDtl'});
            },
            moveDtlPage(page){
              this.pageInfo2.page = page;
              this.fn_dtl_search(this.pageInfo2.code);
            },
            fn_grpCode_click (code,codeNm){
                this.grpCode = code;
                this.grpCodeNm = codeNm;
                this.selectedCode = code;

                this.$store.dispatch('codeMngt/setCode', this.grpCode);
                this.$store.dispatch('codeMngt/setCodeNm', this.grpCodeNm);

                this.fn_dtl_search(code);
            },
            fn_del_dtl(code){

                if(confirm("정말로 삭제하시겠습니까?")){
                  let param = new Object();
                  param.grpCode = this.pageInfo2.code;
                  param.dtlCode = code;

                  axios
                      .post("/api/system/delCodeDtl", param)
                      .then((res) => {
                          this.fn_dtl_search(this.pageInfo2.code);
                      })
                      .catch((err) => console.log(err));
                }
            },
            fn_search_change(){

              //검색 정보 변경 여부
              let searchInfoStore = this.originSearchInfo;

              console.log("@@@@ change searchInfoStore : %o ",searchInfoStore)

              if(searchInfoStore != null && Object.keys(searchInfoStore).length > 0){
                if(this.searchInfo.code !== searchInfoStore.code){
                  this.searchChange = true;
                }
                if(this.searchInfo.codeNm !== searchInfoStore.codeNm){
                  this.searchChange = true;
                }
              }

            console.log("@@@@ fn_search_change searchChange : "+this.searchChange);
            }
        },
    }
</script>